import React from 'react';
import styled from 'styled-components';
import { Input } from 'rbx';

const Container = styled.div`
  padding-top: 4px;
  &&& {
    .input {
      @media screen and (max-width: 1023px) {
        font-size: 0.65rem;
      }
      @media screen and (min-width: 1024px) {
        font-size: 0.55rem;
      }
      @media screen and (min-width: 1216px) {
        font-size: 0.65rem;
      }
      @media screen and (min-width: 1408px) {
        font-size: 0.75rem;
      }
    }
  }
`;

const CustomInput = ({ ...props }) => (
  <Container>
    <Input {...props} />
  </Container>
);

export default CustomInput;
